export default function Footer() {
  return (
    <footer>
      <p>
        take the kill at killtakertheband@gmail.com /
        <a href="https://www.instagram.com/killtaker_/">@killtaker_</a>
      </p>
    </footer>
  );
}
